import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { AttributeTypeWriteRequest } from '@/api/handlers/resources/attributeTypes/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import type { AttributeType } from '@/api/models';
import { AttributeQueryKeys } from './attributeQueryKeys';

export const useCreateAttributeTypeMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<AttributeType>,
        Error,
        AttributeTypeWriteRequest
    >({
        mutationFn: (body) =>
            apiClient.attributeTypes.createAttributeType(body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
